var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"interesting"},[_vm._v(_vm._s(_vm.want ? '' : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }